import React, { useState } from 'react';

import './QueryCreateMain.css';
import Linker from '../../linker/Linker';
import NoiseFilteringDropdown from '../../../container/dropdown/dropdown-query-create/NoiseFilteringDropdown';
import BasicQueryCreate from '../../section/query-create-page/BasicQueryCreate';
import BooleanQueryCreate from '../../section/query-create-page/BooleanQueryCreate';
import ResultQueryCreate from '../../section/query-create-page/ResultQueryCreate';

const   QueryCreateMain = (props) => {
  const pdfPath = "/files/버즈워드 이용 매뉴얼.pdf";

  return (
    // <div style={{display:"flow-root"}}>
    <div className="row featured-main">
      <div id="queryBtnBox">
        <Linker path={pdfPath} download={true} target="_blank">
          {/* <a className="button white" style={{"margin-top":"0px"}}>검색어 작성에 대한 가이드라인 다운로드</a> */}
          <a className="button white" >검색어 작성에 대한 가이드라인 다운로드</a>
        </Linker>
        <NoiseFilteringDropdown
          noiseFilteringData={props.noiseFilters}
          handleCreateBtn={props.addNoiseFilterString}
        />
      </div> 
      <div className="queryBoxLR">
        <div className="queryBox50Left">
          <div className="queryTit"><span className="purple">베이직 검색어</span> 만들기</div>
          <BasicQueryCreate
            andString={props.andString} handleAndString={props.handleAndString}
            orString={props.orString} handleOrString={props.handleOrString}
            notString={props.notString} handleNotString={props.handleNotString}
            handleResultBtn={props.checkQueryResult}
            resultData={props.resultData}
            handleSaveBtn={props.querySave}
            dateRange={props.dateRange}
            userLabelData={props.userLabelData}
          />
        </div>
        <div className="queryBox50Right">
          <div className="queryTit"><span className="purple">불리언 검색어</span> 만들기</div>
          <BooleanQueryCreate
            booleanQuery={props.booleanQuery} handleBooleanQuery={props.handleBooleanQuery}
            handleResultBtn={props.checkQueryResult}
            resultData={props.resultData}
            handleSaveBtn={props.querySave}
            dateRange={props.dateRange}
            userLabelData={props.userLabelData}
            saveTooltip={props.saveTooltip}
          />
        </div>
        <div className="queryTabBtnBox">
          <ResultQueryCreate
            handleRefreshBtn={props.handleRefresh}
            handleDate={props.handleDate}
            dateRange={props.dateRange}
            resultData={props.resultData}
            minDate={props.minDate}
            saveTooltip={props.saveTooltip}
          />
        </div>
      </div>
    </div>
  )
}

export default QueryCreateMain;